import React from "react";
import { Status } from "../../types/common";
import { CommonContextType } from "../../types/context";

export const CommonContext = React.createContext<CommonContextType>({
  setLoaderStatus: (_: Status) => {},
});
